import React from 'react'
import { appHeader} from './../../../styles'
import { withResize } from './../../../hoc/withResize'
import HeaderDesktop from './HeaderDesktop'
import HeaderMobile from './HeaderMobile'


const Header = ({viewport}) => (
  <header className={`app-header ${appHeader}`}>
    {
      viewport.isMobile ? (
        <HeaderMobile />
      ) : (
        <HeaderDesktop />
      )
    }
  </header>
)

export default withResize(Header, {mobile: 1224})


// WEBPACK FOOTER //
// ./src/scenes/Layout/BaseLayout/Header.js